// extracted by mini-css-extract-plugin
module.exports = {"links":"footer_links__27k-1","altContainer":"footer_altContainer__r4MC5"};